export type ApiErrorPayload = {
  code?: string;
  detail?: string;
  message?: string;
  retryable?: boolean;
  errors?: Record<string, string[]>;
  [key: string]: unknown;
};

export class ApiError extends Error {
  statusCode: number;
  code?: string;
  retryable?: boolean;
  payload?: ApiErrorPayload;

  constructor(message: string, statusCode = 0, payload?: ApiErrorPayload) {
    super(message);
    this.name = "ApiError";
    this.statusCode = statusCode;
    this.code = payload?.code;
    this.retryable = payload?.retryable;
    this.payload = payload;
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}

export function isApiErrorLike(error: unknown): error is ApiError {
  return (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    ("statusCode" in error || "status" in error)
  );
}

export function toApiError(error: unknown, fallback = "Request failed"): ApiError {
  if (isApiError(error)) return error;
  if (error instanceof Error) return new ApiError(error.message || fallback);
  if (typeof error === "string") return new ApiError(error || fallback);
  return new ApiError(fallback);
}
